export const headers = [
  "Protocolo",
  "Solicitação",
  "Status",
  "Resposta do especialista"
]

export const CATEGORY_REQUEST = {
  ATIVACAO_COM_PORTABILIDADE: "Portabilidade",
  ATIVACAO_SEM_PORTABILIDADE: "Venda",
  REAGENDAMENTO: "Reagendamento",
  SUSPENSAO: "Suspensão",
  CANCELAMENTO: "Cancelamento"
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/MySpecialistRequests/constants.js